module.exports = __webpack_public_path__ + "img/112.c848bac8.jpg";